"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOvertimePreviewShiftDto = instanceOfOvertimePreviewShiftDto;
exports.OvertimePreviewShiftDtoFromJSON = OvertimePreviewShiftDtoFromJSON;
exports.OvertimePreviewShiftDtoFromJSONTyped = OvertimePreviewShiftDtoFromJSONTyped;
exports.OvertimePreviewShiftDtoToJSON = OvertimePreviewShiftDtoToJSON;
exports.OvertimePreviewShiftDtoToJSONTyped = OvertimePreviewShiftDtoToJSONTyped;
/**
 * Check if a given object implements the OvertimePreviewShiftDto interface.
 */
function instanceOfOvertimePreviewShiftDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('overtimeHours' in value) || value['overtimeHours'] === undefined)
        return false;
    if (!('overtimeCents' in value) || value['overtimeCents'] === undefined)
        return false;
    return true;
}
function OvertimePreviewShiftDtoFromJSON(json) {
    return OvertimePreviewShiftDtoFromJSONTyped(json, false);
}
function OvertimePreviewShiftDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'overtimeHours': json['overtimeHours'],
        'overtimeCents': json['overtimeCents'],
    };
}
function OvertimePreviewShiftDtoToJSON(json) {
    return OvertimePreviewShiftDtoToJSONTyped(json, false);
}
function OvertimePreviewShiftDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'overtimeHours': value['overtimeHours'],
        'overtimeCents': value['overtimeCents'],
    };
}
//# sourceMappingURL=OvertimePreviewShiftDto.js.map